class Resource {
    constructor(simulator, resourceParams) {
        this.simulator = simulator;
        //Store the name and id of the task groups which we can work on
        this.resourceTypes = [resourceParams.resourceName];

        this.isActive = resourceParams.isActive;
        //Start off with no task
        this.currentTask = null;

        //To keep track of the amount of hours remaining for hiring / firing
        this.remHireHours = null;
        this.remFireHours = null;

        this.name = resourceParams.name;
        this.index = resourceParams.index;

        this.workPastHour = 0;
        this.outputPastHour = 0;
        this.lastResourceWorked = null;
    }

    //Set a task to work on
    setCurrentTask(currTask) {
        this.removeCurrentTask();
        this.currentTask = currTask;
        this.currentTask.registerResource(this);

        this.simulator.passedEvents.push({ type: "assignTask", groupName: this.resourceTypes[0], resourceName: this.name, projectIndex: this.currentTask.project.projectIndex, taskID: this.currentTask.taskID, hour: this.simulator.hoursPassed });
    }

    //Dont work on the task anymore
    removeCurrentTask() {
        if (this.currentTask == null) {
            return;
        }

        this.currentTask.unregisterResource();
        this.currentTask = null;
    }

    startHireProcess() {
        this.remHireHours = this.simulator.params.hireTime;
        this.simulator.passedEvents.push({ type: "startHire", groupName: this.resourceTypes[0], index: this.index, hour: this.simulator.hoursPassed })

    }

    startFireProcess() {
        this.remFireHours = this.simulator.params.fireTime;
        this.simulator.passedEvents.push({ type: "startFire", groupName: this.resourceTypes[0], index: this.index, hour: this.simulator.hoursPassed })
    }

    cancelFireProcess() {
        this.remFireHours = null;
        this.simulator.passedEvents.push({ type: "cancelFire", groupName: this.resourceTypes[0], index: this.index, hour: this.simulator.hoursPassed })
    }

    cancelHireProcess() {
        this.remHireHours = null;
        this.simulator.passedEvents.push({ type: "cancelHire", groupName: this.resourceTypes[0], index: this.index, hour: this.simulator.hoursPassed })
    }

    finishFireProcess() {
        this.isActive = false;
        this.remFireHours = null;

        this.simulator.passedEvents.push({ type: "finishFire", groupName: this.resourceTypes[0], index: this.index, hour: this.simulator.hoursPassed })
        this.removeCurrentTask();
    }

    finishHireProcess() {
        this.isActive = true;
        this.remHireHours = null;
        this.simulator.passedEvents.push({ type: "finishHire", groupName: this.resourceTypes[0], index: this.index, hour: this.simulator.hoursPassed })
    }

    //Every iteration, work on the task
    workOnTask(amount) {
 
        if (this.currentTask == null) {
            return;
        }

        if (amount > 0 && !this.isActive) {
            console.error(this);

            throw "Resource tries to work on a task but is inactive";
        }

        //Perform the work, and check if it is finished.
        
        this.outputPastHour = amount;
        this.workPastHour = 1;
        this.lastResourceWorked = this.currentTask.resourceGroupID;
        this.currentTask.performWork(amount);
        var finished = this.currentTask.isFinished();

        if (finished) {
            this.removeCurrentTask();
        }

        return finished;
    }

    updateHireHours() {
        if (this.remHireHours == null) {
            return;
        }

        this.remHireHours -= 1;

        if (this.remHireHours <= 0) {
            this.finishHireProcess();
        }
    }
    updateFireHours() {
        if (this.remFireHours == null) {
            return;
        }

        this.remFireHours -= 1;

        if (this.remFireHours <= 0) {
            this.finishFireProcess();
        }
    }

    updateHours() {
        this.updateHireHours();
        this.updateFireHours();
    }
}


module.exports = { Resource };
